import { render, staticRenderFns } from "./MessageArea.vue?vue&type=template&id=66767d7c&scoped=true&"
import script from "./MessageArea.vue?vue&type=script&lang=ts&"
export * from "./MessageArea.vue?vue&type=script&lang=ts&"
import style0 from "./MessageArea.vue?vue&type=style&index=0&id=66767d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66767d7c",
  null
  
)

export default component.exports